import React, { useState } from "react";
import { Modal, Button, Col, Row, Container } from "react-bootstrap";

const AlertModal = ({
	heading,
	content,
	img,
	btn,
	modalShow,
	setModalShow,
	subContent,
}) => {
	const CloseModal = () => setModalShow();
	return (
		<Modal show={modalShow} onHide={CloseModal} size='lg' center>
			<Modal.Header closeButton></Modal.Header>
			<Modal.Body className='pr-5 pl-5 pt-0'>
				<Container className='text-center text-white'>
					<div style={{ height: 50 }}></div>
					<h1 className='h1'>{heading}</h1>
					<p style={{ fontSize: 18 }}>
						{content}
						{subContent && (
							<>
								{" "}
								<br /> {subContent}{" "}
							</>
						)}
					</p>
					<p className='mt-5'>
						<img
							style={{ height: "100%", maxHeight: 350, width: "auto" }}
							src={img}
						/>
					</p>
					<Button onClick={CloseModal} className='mt-5 mb-5 btn btn-warning'>
						{btn}
					</Button>
				</Container>
			</Modal.Body>
		</Modal>
	);
};

export default AlertModal;
